export const ALL_POKEMONS_REQUEST = 'ALL_POKEMONS_REQUEST';
export const ALL_POKEMONS_SUCCESS = 'ALL_POKEMONS_SUCCESS';
export const ALL_POKEMONS_FAIL ='ALL_POKEMONS_FAIL';

//  poke url
// export const ADD_POKEMON_TO_WISHLIST_REQUEST = 'ADD_POKEMON_TO_WISHLIST_REQUEST';
// export const ADD_POKEMON_TO_WISHLIST_SUCCESS = 'ADD_POKEMON_TO_WISHLIST_SUCCESS' ;
// export const ADD_POKEMON_TO_WISHLIST_FAIL = 'ADD_POKEMON_TO_WISHLIST_FAIL';

// export const REMOVE_FROM_WISHLIST_SUCCESS = 'REMOVE_FROM_WISHLIST_SUCCESS';
// export const REMOVE_FROM_WISHLIST_FAIL ='REMOVE_FROM_WISHLIST_FAIL';

//start testing
export const LOAD_DATA_REQUEST = 'LOAD_DATA_REQUEST' 
export const LOAD_DATA_SUCCESS = 'LOAD_DATA_SUCCESS' 
export const LOAD_DATA_FAILURE = 'LOAD_DATA_FAILURE' 


export const CLEAR_ERRORS = 'CLEAR_ERRORS';







